import React from "react";

import { AppBar, Box, Drawer, IconButton, Stack, Toolbar } from "@mui/material";
import { MenuOpen } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import { Spinner } from "@/components/atoms";
import { useLogo } from "@/utils";

const LoadingLayout: React.FC = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const logoConfig = useLogo();

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        overflow: "hidden",
        height: "100vh",
        width: "100vw",
        minWidth: "1028px",
      }}
    >
      <AppBar
        color="inherit"
        position="absolute"
        sx={{ zIndex: theme.zIndex.drawer + 1 }}
      >
        <Toolbar variant="dense" sx={{ mx: -1 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <IconButton>
                <MenuOpen />
              </IconButton>
              {logoConfig && (
                mode === 'dark' ? (
                  <Box sx={{ flexGrow: 0, width: logoConfig.main.width, height: logoConfig.main.height, mr: 2 }}>
                    {<logoConfig.main.logo />}
                  </Box>
                ) : (
                  <Box sx={{ flexGrow: 0, width: logoConfig.dark.width, height: logoConfig.dark.height, mr: 2 }}>
                    {<logoConfig.dark.logo />}
                  </Box>
                )
              )}
              {logoConfig && logoConfig.alt && (
                <Box sx={{ flexGrow: 0, width: logoConfig.alt.width, height: logoConfig.alt.height, mr: 2 }}>
                  {<logoConfig.alt.logo />}
                </Box>
              )}
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <Toolbar variant="dense" sx={{ displayPrint: "none" }} />
        <Box
          component="main"
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            width: "100%",
            height: "100vh",
            minWidth: "1028px",
          }}
        >
          <Spinner />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingLayout;
